export default __webpack_public_path__ + "images/c67833e3ceb27191bda66ed5c82ca220-emoji-hurting.svg";